import { FormGroup } from '@vtbhome/juicyfront';
import { styled } from 'goober';

export const Wrapper = styled('div')`
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 8px;
`;

export const StyledFormGroup = styled(FormGroup)<{ $error?: string }>`
    .rf-form-group__message {
        ${({ $error }) => !$error && 'margin-top: 0;'}
    }
`;

export const FilesList = styled('div')`
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 8px;
`;
